import React from 'react';
import { IconProps } from '../types';
const MinecraftBakedPotato: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="3" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(175, 132, 68, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(213, 172, 55, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(213, 172, 55, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(181, 152, 64, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(213, 172, 55, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(213, 172, 55, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="14" y="7" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(175, 132, 68, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(213, 172, 55, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(213, 172, 55, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(240, 205, 90, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(213, 172, 55, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(181, 152, 64, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(134, 105, 62, 255)" />
<rect x="14" y="9" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(213, 172, 55, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(181, 152, 64, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(154, 85, 0, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(181, 152, 64, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(181, 152, 64, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(175, 132, 68, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(134, 105, 62, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(181, 152, 64, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(217, 170, 81, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(200, 151, 58, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(134, 105, 62, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(175, 132, 68, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(175, 132, 68, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(157, 119, 46, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(109, 55, 1, 255)" />
</svg>);
export default MinecraftBakedPotato;